export const searchFormInitialValues = {
  searchTerm: '',
  categoryId: '',
  hotelId: '',
  countryId: '',
  regionId: '',
  companyId: '',
  published: '',
};
